// import Vue from "vue";
// import Router from "vue-router";
import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Begin from '../components/begin'
import EnterHS from '../components/enterHS'
import HsCulture from '../components/hsCulture'
import HsInvestEducation from '../components/hsInvestEducation'
import HsEngage from '../components/hsEngage'
import SystemManage from '../components/systemManage'
import LoveholicManage from '../components/loveholicManage'
import Login from '../components/login'

Vue.use(Router)

/**
 * 重写路由的push方法
 */

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

// import HelloWorld from '@/components/HelloWorld'
// import OverView from '@/pages/overview'
// import RuleManage from '@/pages/ruleManage'
// import TaskManage from '@/pages/taskManage/taskManage'
// import TaskConfiguration from '@/pages/taskManage/taskConfiguration'
// import WarningManage from '@/pages/warningManage' // 先加载子组件
// import QualityReportDetail from '@/pages/qualityReportDetail'  // 提前子组件加载
// import demos from '@/pages/demos'
Vue.use(Router);

const router = new Router({
  routes: [
    {
        path: '/',
        name: 'Begin',
        component: Begin
    },
    {
        path: '/begin',
        name: 'Begin',
        component: Begin
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/enterHS',
        name: 'EnterHS',
        component: EnterHS
    },
    {
        path: '/hsCulture',
        name: 'HsCulture',
        component: HsCulture
    },
    {
        path: '/systemManage',
        name: 'SystemManage',
        component: SystemManage
    },
    {
        path: '/loveholicManage',
        name: 'LoveholicManage',
        component: LoveholicManage
    },
    {
        path: '/hsInvestEducation',
        name: 'hsInvestEducation',
        component: HsInvestEducation
    },
    {
        path: '/hsEngage',
        name: 'hsEngage',
        component: HsEngage
    },
    {
        path: '/index',
        name: 'Index',
        component: Index
    },
]
  // routes: [
  //   {
  //     path: '/',
  //     redirect: '/overview'
  //   },
  //   {
  //     path: '/',
  //     component: () => import(/* webpackChunkName: "home" */ '@/pages/common.vue'), // 5.js, 按需记载
  //     meta: { title: '概况' },
  //     children: [
  //       {
  //         path: '/overview',
  //         name: 'overview',
  //         // component: OverView,
  //         component: () => import('@/pages/overview'), // 6.js, 按需记载
  //         meta: { title: '概况' }
  //       },
  //       {
  //         path: '/ruleManage',
  //         name: 'ruleManage',
  //         // component: RuleManage,
  //         component: () => import('@/pages/ruleManage'), // 7.js
  //         meta: { title: '规则管理' }
  //       },
  //       {
  //         path: '/taskManage',
  //         name: 'taskManage',
  //         // component: TaskManage,
  //         component: () => import('@/pages/taskManage/taskManage'), // 4.js
  //         meta: { title: '任务管理' },
  //       },
  //       {
  //         path: '/taskConfiguration',
  //         name: 'taskConfiguration',
  //         // component: TaskConfiguration,
  //         component: () => import('@/pages/taskManage/taskConfiguration'), // 2.js
  //         meta: { title: '新建任务' }
  //       },
  //       {
  //         path: '/demos',
  //         name: 'demos',
  //         // component: demos,
  //         component: () => import('@/pages/demos'), // 8.js
  //         meta: { title: 'demos' }
  //       },
  //       {
  //         path: '/warningManage',
  //         name: 'warningManage',
  //         // component: WarningManage,
  //         component: () => import('@/pages/warningManage'), // 3.js
  //         meta: { title: '告警管理' }
  //       },
  //       {
  //         path: '/quality-report-detail',
  //         name: 'quality-report-detail',
  //         // component: QualityReportDetail,
  //         component: () => import('@/pages/qualityReportDetail'), // 1.js
  //         meta: { title: '查看质量报告' }
  //       }
  //     ]
  //   },
  // ]
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js